import { queryParamHookFactory } from '../../../modules/taboola-common-frontend-modules/query-params';
import { PERSISTENCE_TYPE } from '../../../modules/taboola-common-frontend-modules/storage';

export const CHAT_DEV_TOOL_PARAM_NAME = 'chat-dev-tool';

export const useChatDevTool = queryParamHookFactory(CHAT_DEV_TOOL_PARAM_NAME, {
    persist: PERSISTENCE_TYPE.MEMORY,
});
